import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const smartListsApi = createApi({
  reducerPath: "smartListsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["CallToday", "StaleLeads", "OverdueFollowUps"],
  endpoints: (build) => ({
    getCallTodayList: build.query({
      query: (params = {}) => ({ url: "/smart-lists/call-today", params }),
      providesTags: ["CallToday"],
      transformResponse: (res) => res.data || [],
    }),
    getStaleLeads: build.query({
      query: (params = {}) => ({ url: "/smart-lists/stale", params }),
      providesTags: ["StaleLeads"],
      transformResponse: (res) => res.data || [],
    }),
    getOverdueFollowUps: build.query({
      query: (params = {}) => ({ url: "/smart-lists/overdue-followups", params }),
      providesTags: ["OverdueFollowUps"],
      transformResponse: (res) => res.data || [],
    }),
    // Log the outcome of a call from the dashboard widget — writes a
    // CommunicationLog row and bumps Client.lastContact so the
    // contact drops off the smart list automatically.
    logCallTodayCall: build.mutation({
      query: ({ clientId, ...body }) => ({
        url: `/smart-lists/call-today/${clientId}/log`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["CallToday", "StaleLeads", "OverdueFollowUps"],
    }),
    // Snooze a contact off Call Today until tomorrow without writing
    // a fake log. Useful for "not now" passes.
    dismissCallTodayContact: build.mutation({
      query: ({ clientId }) => ({
        url: `/smart-lists/call-today/${clientId}/dismiss`,
        method: "POST",
      }),
      invalidatesTags: ["CallToday"],
    }),
  }),
});

export const {
  useGetCallTodayListQuery,
  useGetStaleLeadsQuery,
  useGetOverdueFollowUpsQuery,
  useLogCallTodayCallMutation,
  useDismissCallTodayContactMutation,
} = smartListsApi;
